import React from 'react'
import styles from './Logo.module.scss'
import { Link } from 'react-router-dom'
import { ROUTES } from '../../../routes'

export default function Logo() {
  return (
    <Link to={ROUTES.home.path} className={styles.logo}>
      <img src="/assets/images/fcd-logo.png" alt="FC Doggen logo" />
    </Link>
  )
}
